import brou from './brou.png';
import santander from './santander.jpg';
import bbva from './bbva.jpg';
import hsbc from './hsbc.jpg';
import itau from './bancoitauuruguay.jpg';
import prex from './prex.png';
import scotiabankuruguay from './scotiabankuruguay.jpg';

// import bancoNacionArgentina from './banco_nacion_argentina.png';
// import cacdu from './hsbc.jpg';
// import bhu from './bhu.png';
// import abnamrobank from './abnamaro.png';
// import americaexpress from './america_express.png';
// import surinvest from './hsbc.jpg';
// import cofac from './cofac.jpg';
// import citibank from './citibank.jpg';
// import centrohispano from './hsbc.jpg';
// import banking from './banking.png';
// import bankbrasil from './bancobrasil.png';
// import bankdiscount from './bankdiscount.jpg';
// import bancocajaobrera from './hsbc.jpg';
// import bacosudameris from './sudameris.png';
// import bancoreal from './banco_real.png';
// import bpa from './hsbc.jpg';
// import bancomontevideo from './hsbc.jpg';
// import bancodecredito from './hsbc.jpg';
// import caycu from './hsbc.jpg';

// import bandesuruguay from './bandes.jpg';
// import visa from './visa.png';
// import mastercard from './mastercard.png';

const bankNames = {
  brou: 'Brou',
  santander: 'Santander',
  bancobbva: 'BBVA',
  hsbcrepublicnationalbankofnewyork: 'HSBC',
  itaú: 'Itaú',
  fpspaymentsolutions: 'Prex',
  scotiabankuruguay: 'Scotiabank',
  // visa: 'Visa',
  // emprendimientosdevalor: 'Mastercard',
};

const bankImages = {
  brou,
  santander,
  bancobbva: bbva,
  hsbcrepublicnationalbankofnewyork: hsbc,
  itaú: itau,
  fpspaymentsolutions: prex,
  scotiabankuruguay,
  // visa,
  // emprendimientosdevalor: mastercard,
};

export default (key) => {
  if (!bankNames[key] || !bankImages[key]) {
    console.log(key);
    console.log(bankNames, bankImages);
    return null;
  }
  return [bankNames[key], bankImages[key]];
};



// WEBPACK FOOTER //
// ./src/assets/images/index.js